import React from "react";
import PropTypes from "prop-types";
import { MultiInput } from "react-invenio-forms";

/**
 * A `MultiInput` for a core metadata field rendered through the custom fields config.
 *
 * The custom fields loader always builds the field path as
 * `custom_fields.<field>`, overriding any `fieldPath` passed in `props`. Some
 * metadata fields (e.g. formats, sizes) have no widget in the deposit form, so
 * we declare them as custom fields and point them back at `metadata.<name>`
 * through `metadataField`.
 */
export const MetadataMultiInput = ({
  metadataField,
  label,
  icon,
  placeholder,
  description,
  required,
}) => (
  <MultiInput
    fieldPath={`metadata.${metadataField}`}
    label={label}
    icon={icon}
    placeholder={placeholder}
    description={description}
    required={required}
  />
);

MetadataMultiInput.propTypes = {
  metadataField: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string,
  required: PropTypes.bool,
};

MetadataMultiInput.defaultProps = {
  icon: undefined,
  required: false,
};
